import { render, staticRenderFns } from "./LogoBox.vue?vue&type=template&id=45f84321"
import script from "./LogoBox.vue?vue&type=script&lang=js"
export * from "./LogoBox.vue?vue&type=script&lang=js"
import style0 from "./LogoBox.vue?vue&type=style&index=0&id=45f84321&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports